import SetupTwoFAPage from "./SetupTwoFaSwitch";
import VerifyTwoFAPage from "./VerifyTwoFAPageSwitch";
import {
  TWO_FA_REQUIRED,
  SET_UP_2FA_TITLE,
  SET_UP_2FA_MESSAGE1,
  SET_UP_2FA_MESSAGE2,
  SEND_VERIFICATION_CODE,
  VERIFY_2FA_MESSAGE1,
  VERIFY_2FA_MESSAGE2,
  EMAIL_TOKEN_ERROR_MESSAGE,
  RESEND_CODE,
  VERIFY_CODE,
  BACK_TO_LOGIN,
  UPDATE_2FA_MOBILE_NUMBER,
  SEND_VERIFICATION_EMAIL_MESSAGE1,
  SEND_VERIFICATION_EMAIL_MESSAGE2,
  INVALID_EMAIL_MESSAGE,
  ACCOUNT_LOCKED_MESSAGE,
} from "./constants";
import { getCensorEmail } from "./utils";
export {
  SetupTwoFAPage,
  VerifyTwoFAPage,
  TWO_FA_REQUIRED,
  SET_UP_2FA_TITLE,
  SET_UP_2FA_MESSAGE1,
  SET_UP_2FA_MESSAGE2,
  SEND_VERIFICATION_CODE,
  VERIFY_2FA_MESSAGE1,
  VERIFY_2FA_MESSAGE2,
  EMAIL_TOKEN_ERROR_MESSAGE,
  RESEND_CODE,
  VERIFY_CODE,
  BACK_TO_LOGIN,
  UPDATE_2FA_MOBILE_NUMBER,
  SEND_VERIFICATION_EMAIL_MESSAGE1,
  SEND_VERIFICATION_EMAIL_MESSAGE2,
  INVALID_EMAIL_MESSAGE,
  ACCOUNT_LOCKED_MESSAGE,
  getCensorEmail,
};



// WEBPACK FOOTER //
// ./components/twoFA/index.js